﻿import { useEffect, useState } from 'react';

const Checkbox = ({
    id,
    text,
    handleAnswer,
    ...props
}) => {

    const [buttonText, setButtonText] = useState('')
    const [checked, setChecked] = useState(false)

    const downloadQuestion = '5919a64a-884d-4a5c-80f3-f3d63e68b2f5'

    useEffect(() => {
        if (id && id === downloadQuestion) {
            setButtonText("Jag har tagit del och förstått")
        } else { setButtonText("Jag förstår") }
    }, [id])
    
    const handleChange = (answer, id) => {
        handleAnswer(answer, id)
        setChecked(event.target.checked)
    }

    return (
        <>
            <label
                className="button button--green checkbox"
                htmlFor={id}
                >
                <input
                    checked={checked}
                    id={id}
                    type="checkbox"
                    value="True"
                    onChange={(e) => handleChange(e.target.value, id)}
                    onKeyDown={(event) => event.key === 'Enter' && event.preventDefault()}
                />{buttonText}
            </label>
        </>
     )
}

export default Checkbox;